
import { Button } from "@/components/ui/button";
import { Slab } from "@/types/slab";
import { SlabEditImage } from "./slab/SlabEditImage";
import { SlabEditFields } from "./slab/SlabEditFields";
import { SlabDimensionsFields } from "@/components/admin/products/SlabDimensionsFields";
import { useSlabForm } from "@/hooks/useSlabForm";

interface SlabEditFormProps {
  slab: Slab;
  onClose: () => void;
  onUpdate: (updatedSlab: Slab) => void;
}

export function SlabEditForm({ slab, onClose, onUpdate }: SlabEditFormProps) {
  const {
    formData,
    setFormData,
    isSubmitting,
    errors,
    materialTypes,
    handleImageChange,
    handleDimensionsChange,
    handleQuantityChange,
    handleSubmit
  } = useSlabForm(slab, onUpdate, onClose);

  return (
    <form onSubmit={handleSubmit} className="space-y-4 max-h-[calc(100vh-8rem)] overflow-y-auto">
      <SlabEditImage
        imageUrl={formData.imageUrl}
        name={formData.name}
        onImageChange={handleImageChange}
      />

      <SlabEditFields
        formData={formData}
        setFormData={setFormData}
        errors={errors}
        materialTypes={materialTypes}
      />

      <SlabDimensionsFields
        formData={formData}
        onDimensionsChange={handleDimensionsChange}
        onQuantityChange={handleQuantityChange}
      />

      <div className="flex justify-end gap-2 pt-4">
        <Button variant="outline" type="button" onClick={onClose}>
          Cancelar
        </Button>
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Salvando..." : "Salvar Alterações"}
        </Button>
      </div>
    </form>
  );
}
